var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50004 14.1667H5.83337V8.33333H7.50004V14.1667ZM10.8334 14.1667H9.16671V5.83333H10.8334V14.1667ZM14.1667 14.1667H12.5V10.8333H14.1667V14.1667ZM16.25 14.9167C16.25 15.469 15.8023 15.9167 15.25 15.9167H4.75004C4.19776 15.9167 3.75004 15.469 3.75004 14.9167V5.16667C3.75004 4.61438 4.19776 4.16667 4.75004 4.16667H15.25C15.8023 4.16667 16.25 4.61438 16.25 5.16667V14.9167ZM16.25 2.5H3.75004C2.83337 2.5 2.08337 3.25 2.08337 4.16667V15.8333C2.08337 16.75 2.83337 17.5 3.75004 17.5H16.25C17.1667 17.5 17.9167 16.75 17.9167 15.8333V4.16667C17.9167 3.25 17.1667 2.5 16.25 2.5Z",
    fill: "#6D7284"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.8a803814.svg";
export { ForwardRef as ReactComponent };